import { Component, inject } from '@angular/core';

import { Router } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatStepperModule } from '@angular/material/stepper';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-contracts-component',
  standalone: true,
  imports: [
    MatStepperModule,
    MatButtonModule
  ],
  templateUrl: './contracts-component.html',
  styleUrls: ['./contracts-component.scss']
})
export class ContractsComponent {
  private router = inject(Router);
  private sanitizer = inject(DomSanitizer);

  pdfVisible = false;
  pdfUrl!: SafeResourceUrl;

  customers = [
    {
      id: '123456',
      name: 'M Blockstrand',
      voucher: '34532',
      status: '1/9/25',
      contract: '../../assets/Contract.pdf'
    },
    {
      id: '65342345',
      name: 'G Smith',
      voucher: '231234',
      status: '29/8/25',
      contract: '../../assets/Contract.pdf'
    },
    {
      id: '22423534',
      name: 'E Presley',
      voucher: '134345',
      status: '27/8/25',
      contract: '../../assets/Contract.pdf'
    }
  ];

  viewContract(contractUrl: string) {
    this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(contractUrl);
    this.pdfVisible = true;
  }
}
